<template>
  <div class="container is-max-width-desctop">
    <section class="section is-large">
      <h1 class="title has-text-centered">Back office into-it</h1>
      <div class="is-flex is-align-items-center is-justify-content-center">
        <form action="#" @submit.prevent="login">
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input class="input" type="email" v-model="email" placeholder="Email">
              <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
              <span class="icon is-small is-right">
              <i class="fas fa-check"></i>
            </span>
            </p>
          </div>
          <div class="field">
            <p class="control has-icons-left">
              <input class="input" type="password" v-model="password" placeholder="Password">
              <span class="icon is-small is-left">
              <i class="fas fa-lock"></i>
            </span>
            </p>
          </div>
          <div class="field">
            <p class="control">
              <button type="submit" class="button is-success">
                Login
              </button>
            </p>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import {login} from "../api/api"

export default {
  name: 'App',
  components: {},
  data() {
    return {
      email: '',
      password: '',
    }
  },
  methods: {
    async login() {
      try {
        const resp = await login(this.email, this.password)
            .then(resp => resp.data)

        const date = new Date(resp.expires_at)

        this.$emit('logged-in', {expiresAt: date.getTime(), token: resp.token})
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>
